import * as yup from 'yup'
import { ORGANIZATION_TITLE_MAX_LENGTH } from './organizationLimits'

export const paymentValidationSchema = {
  details: yup.object().shape({
    firstName: yup.string().required('requiredField'),
    lastName: yup.string().required('requiredField'),
    username: yup.string().required('requiredField'),
    email: yup.string().email('invalidEmail').required('requiredField'),
    privacyPolicy: yup.bool().oneOf([true], 'requiredField'),
    termsAndConditions: yup.bool().oneOf([true], 'requiredField'),
    endUserLicenseAgreement: yup.bool().oneOf([true], 'requiredField'),
  }),
  billing: yup.object().shape({
    // Server-side this is validated against BillingAddress.company_name,
    // varchar(100), but at provisioning it also becomes Organization.title,
    // varchar(64). Without this cap a name between the two lengths passes
    // checkout and then kills the webhook that creates the account.
    companyName: yup
      .string()
      .max(ORGANIZATION_TITLE_MAX_LENGTH, 'companyNameTooLong')
      .required('requiredField'),
    companyEmail: yup.string().email('invalidEmail').required('requiredField'),
    companyTaxId: yup.string().required('requiredField'),
    country: yup.string().required('requiredField'),
    state: yup.string().required('requiredField'),
    city: yup.string().required('requiredField'),
    postalCode: yup.string().required('requiredField'),
    addressLine1: yup.string().required('requiredField'),
    addressLine2: yup.string().optional(),
  }),
}
